import { Component } from 'react'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from 'react-places-autocomplete'

import Input from '../Input'
import styles from './Autocomplete.module.scss'

const renderFunc = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
  <div className={styles.autocomplete}>
    <Input
      required
      {...getInputProps({
        label: 'Hotel physical address',
        isFullWidth: true,
        autoComplete: 'disabled'
      })}
      autoComplete="disabled"
    />
    <div className={styles.suggestions}>
      {suggestions.map(suggestion => {
        const className = suggestion.active
          ? styles.suggestionItemActive
          : styles.suggestionItem
        return (
          <div
            {...getSuggestionItemProps(suggestion, {
              className
            })}
          >
            <span>{suggestion.description}</span>
          </div>
        )
      })}
    </div>
  </div>
)

const invoiceRenderFunc = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
  <div className={styles.autocomplete}>
    <Input
      required
      {...getInputProps({
        label: 'Invoice address',
        isFullWidth: true
      })}
    />
    <div className={styles.suggestions}>
      {suggestions.map(suggestion => {
        const className = suggestion.active
          ? styles.suggestionItemActive
          : styles.suggestionItem
        return (
          <div
            {...getSuggestionItemProps(suggestion, {
              className
            })}
          >
            <span>{suggestion.description}</span>
          </div>
        )
      })}
    </div>
  </div>
)

class Autocomplete extends Component {
  constructor(props) {
    super(props)
    this.state = { address: '', addressObject: {} }
  }

  handleChange = address => {
    this.setState({ address })
  }

  addressFormatHandler = component => {
    const { types } = component
    if (types.indexOf('country') > -1) {
      this.setState(prevState => ({
        ...prevState,
        addressObject: {
          ...prevState.addressObject,
          countryCode: component['short_name']
        }
      }))
    }
    if (types.indexOf('street_number') > -1) {
      this.setState(prevState => ({
        ...prevState,
        addressObject: {
          ...prevState.addressObject,
          streetAddress:
            (prevState.addressObject.streetAddress || '') + component['short_name'] + ' '
        }
      }))
    }
    if (types.indexOf('route') > -1) {
      this.setState(prevState => ({
        ...prevState,
        addressObject: {
          ...prevState.addressObject,
          streetAddress:
            (prevState.addressObject.streetAddress || '') + component['long_name']
        }
      }))
    }
    if (types.indexOf('locality') > -1) {
      this.setState(prevState => ({
        ...prevState,
        addressObject: {
          ...prevState.addressObject,
          city: component['long_name']
        }
      }))
    }
    if (types.indexOf('administrative_area_level_1') > -1) {
      this.setState(prevState => ({
        ...prevState,
        addressObject: {
          ...prevState.addressObject,
          state: component['short_name']
        }
      }))
    }
    if (types.indexOf('postal_code') > -1) {
      this.setState(prevState => ({
        ...prevState,
        addressObject: {
          ...prevState.addressObject,
          postalCode: component['long_name']
        }
      }))
    }
  }

  handleSelect = address => {
    const { setAddressObject, setBillingInfo, setRawAddress, setTimezoneData } =
      this.props

    geocodeByAddress(address)
      .then(results => {
        this.setState(prevState => ({ ...prevState, addressObject: {} }))
        results[0]['address_components'].map(component =>
          this.addressFormatHandler(component)
        )
        setAddressObject && setAddressObject(this.state.addressObject)
        setRawAddress && setRawAddress(results)
        setBillingInfo && setBillingInfo(results[0]['formatted_address'])
        this.setState({ address: results[0]['formatted_address'] })
        return results
      })
      .then(results => getLatLng(results[0]))
      .then(latLng =>
        fetch(
          `https://maps.googleapis.com/maps/api/timezone/json?location=${latLng.lat},${
            latLng.lng
          }0&timestamp=${Date.now() / 1000}&key=AIzaSyB2Q7iadrg9-SaymDF_l5pUOhLaOiW01vM`
        )
      )
      .then(data => data.json())
      .then(data => setTimezoneData && setTimezoneData(data))
      .catch(error => console.error('Error', error))
  }

  render() {
    return (
      <PlacesAutocomplete
        value={
          this.props.fromBilling
            ? this.state.address || this.props.fromBilling
            : this.state.address
        }
        onChange={this.handleChange}
        onSelect={this.handleSelect}
      >
        {this.props.invoice ? invoiceRenderFunc : renderFunc}
      </PlacesAutocomplete>
    )
  }
}

export default Autocomplete
